import { productFormSubmit, variantChange } from './../../../scripts/helpers/product-form'
import { getLocalURL } from '../../../scripts/helpers/globale'

export default class ProductFormFixed {
  constructor(component) {
    this.dom = {
      $component: component,
      $container: component.querySelector('.js-fixedFormContainer'),
      $singleOptionSelectors: component.querySelectorAll('.js-fixedSingleOptionSelector'),
      $options: component.querySelectorAll('.js-fixedOptionBtn'),
      $regularSubmitBtn: document.querySelector('.js-regularSubmitBtn'),
      $variantIdInput: component.querySelector('.js-variantId'),
      $price: component.querySelector('.js-price .currency-formatting'),
      $compareAtPrice: component.querySelector('.js-compareAtPrice'),
      $submitBtn: component.querySelector('.js-productFormSubmit'),
      $swatchContainer: component.querySelector('.js-fixedColorOptions'),
      $stars: component.querySelector('.js-fixedReviews'),
      $optionText: component.querySelector('.js-optionText'),
      $collectionBreadcrumb: document.querySelector('.js-breadcrumbItem'),
      $fixedOptionsContainer: document.querySelectorAll('.js-fixedOptionsContainer'),
    }
    this.state = {
      isFixedForm: true,
      selectedOptions: {},
      showFormClass: 'showFixedForm',
      openOptions: null,
      openOptionsClass: 'openOptions',
      selectedOptionClass: 'activeOption',
      altSelectedOptionClass: 'selectedOption',
      optionTextClass: 'js-optionText',
      swatches: [],
      activeSwatch: null,
      swatchesLoaded: false,
    }
    this.singleOptionSelectorClickHandler = this.singleOptionSelectorClick.bind(this)
    this.optionClickHandler = this.optionClick.bind(this)
    this.optionClickOutHandler = this.optionClickOut.bind(this)
    this.submitHandler = this.submit.bind(this)
    this.loadSwatchHandler = this.onLoadSwatches.bind(this)

    this.mount()
    this.mountYotpoStars()
    this.bindToWindow()
  }

  mountYotpoStars() {
    const { dom } = this
    const targetNode = dom.$stars.querySelector('.yotpo.bottomLine')
    const config = { childList: true }

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const yotpoStarsCount = dom.$stars.querySelector('.yotpo-display-wrapper .sr-only')
          const yotpoStarsLink = dom.$stars.querySelector('.yotpo-display-wrapper .yotpo-bottomline a')

          if (yotpoStarsLink && yotpoStarsCount &&
              yotpoStarsCount.innerHTML !== '' && !yotpoStarsCount.innerHTML.includes('0.0')
          ) {
            const starCount = yotpoStarsCount.innerHTML.replace('star rating', '').trim()
            yotpoStarsLink.innerHTML = starCount
          }

          observer.disconnect()
        }
      }
    }

    const observer = new MutationObserver(callback)

    observer.observe(targetNode, config)
  }

  mount() {
    const { dom } = this
    this.setSelectedOptions()
    dom.$singleOptionSelectors.forEach($selector => $selector.addEventListener('click', this.singleOptionSelectorClickHandler))
    dom.$options.forEach($option => $option.addEventListener('click', this.optionClickHandler))
    dom.$submitBtn.addEventListener('click', this.submitHandler)
    document.addEventListener('swatchesloaded', this.loadSwatchHandler)
    this.observe()
    window.basis.EventBus.listen('refresh-fixed-variants', (productData) => {
      this.updateVariantOptions(productData)
    })

    window.basis.EventBus.listen('setSelectOptions', () => {
      this.setSelectedOptions()
    })

    window.basis.EventBus.listen('set-active-fixed-swatch', (optionValue) => {
      const { state } = this
      state.activeSwatch = optionValue
    })
  }

  updateVariantOptions(productData) {
    const { dom } = this
    dom.$fixedOptionsContainer.forEach((option) => {
      if (option.dataset.option !== 'color') {
        const buttons = this.createFixedVariantSwatch(productData, option)
        option.innerHTML = buttons.join('')
        dom.$options = dom.$component.querySelectorAll('.js-fixedOptionBtn')
        dom.$options.forEach((button) => {
          button.addEventListener('click', this.optionClickHandler)
        })
      }
    })
  }

  onLoadSwatches({ detail }) {
    const { state } = this
    const data = JSON.parse(JSON.stringify(detail))

    state.swatches = data.products.sort((a, b) => {
      return a.colorHandle.localeCompare(b.colorHandle)
    })
    state.activeSwatch = data.color
    this.mountSwatches()
    state.swatchesLoaded = true

    document.removeEventListener('swatchesloaded', this.loadSwatchHandler)
  }

  mountSwatches() {
    const { state } = this
    const activeSwatch = state.swatches.find(({ color }) => color === state.activeSwatch)
    activeSwatch.active = true
    state.selectedOptions.color = activeSwatch.colorHandle

    state.swatches.forEach((swatch) => {
      this.createSwatch(swatch)
    })
  }

  createFixedVariantSwatch(productData, option) {
    const { state } = this
    const { options, variants } = productData
    const sanitizeOptions = options.map((optionItem) => {
      return optionItem.toLowerCase()
    })
    const index = sanitizeOptions.indexOf(option.dataset.option)
    const optionType = sanitizeOptions[index]
    const selected = state.selectedOptions[sanitizeOptions[index]]

    const buttons = variants.map((variant) => {
      const value = variant.options[index]
      const selectClass = variant.options[index] === selected ? 'activeOption' : ''
      const soldOutClass = variant.available === true ? '' : 'soldOut'

      return `
        <button
          class="ProductFormFixed__optionBtn js-fixedOptionBtn ${selectClass} ${soldOutClass}" data-value="${value}" data-option-type="${optionType}" aria-label="Select ${value} option">
          <span class="btn-link">${value}</span>
        </button>
      `
    })

    return buttons
  }

  createSwatch(swatch) {
    const { state, dom } = this
    const breadcrumbLink = this.dom.$collectionBreadcrumb
    const collectionUrl = breadcrumbLink ? breadcrumbLink.attributes.href.value : ''
    const button = document.createElement('button')
    button.classList.add('ProductFormFixed__optionBtn')
    button.classList.add('js-fixedOptionBtn')
    button.classList.add('js-fixedOptionBtnColor')
    if (swatch.active) {
      button.classList.add(state.selectedOptionClass)
    }
    button.dataset.value = swatch.colorHandle
    button.dataset.relatedProductUrl = getLocalURL(swatch.url)

    if (collectionUrl) {
      button.dataset.relatedProductUrl = `${collectionUrl}${swatch.url}`
    }
    button.dataset.optionType = 'color'
    button.value = swatch.colorHandle
    button.ariaLabel = `Select ${swatch.colorFormatted} color option`
    button.innerHTML = `
      <span class="Swatch productFormFixed">
        <span
          class="Swatch__inset productSwatch"
          data-color="${swatch.colorHandle}"
        ></span>
      </span>
    `

    button.addEventListener('click', this.optionClickHandler)

    dom.$swatchContainer.append(button)
    swatch.rendered = true
  }

  setSelectedOptions() {
    const { dom, state } = this
    dom.$component.querySelectorAll(`.${state.selectedOptionClass}`).forEach(btn => {
      const { optionType, value } = btn.dataset
      state.selectedOptions[optionType] = value
    })
  }

  observe() {
    const { dom } = this
    const observer = new IntersectionObserver(this.onIntersection.bind(this), {
      root: null,
      threshold: 0,
    })
    observer.observe(dom.$regularSubmitBtn)
  }

  onIntersection(entries) {
    const { dom, state } = this
    const entry = entries[0]

    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
      dom.$component.classList.add(state.showFormClass)
    } else {
      if (state.openOptions) {
        this.closeOpenOption()
        state.openOptions = null
      }
      dom.$component.classList.remove(state.showFormClass)
    }
  }

  singleOptionSelectorClick(event) {
    const { state } = this
    const { option } = event.currentTarget.dataset

    if (state.openOptions === option) {
      this.closeOpenOption()
      state.openOptions = null
      return
    }

    if (state.openOptions) {
      this.closeOpenOption()
    }

    this.openOption(option)
    state.openOptions = option
  }

  optionClickOut(event) {
    const { dom, state } = this
    if (!dom.$component.contains(event.target)) {
      this.closeOpenOption()
      state.openOptions = null
    }
  }

  closeOpenOption() {
    const { dom, state } = this
    const activeContainer = dom.$component.querySelector(`.js-fixedOptionsContainer[data-option="${state.openOptions}"]`)
    if (!activeContainer) {
      return
    }
    const activeButton = dom.$component.querySelector(`.js-fixedSingleOptionSelector[data-option="${state.openOptions}"]`)
    activeContainer.classList.remove(state.openOptionsClass)
    activeButton.classList.remove(state.openOptionsClass)
    document.removeEventListener('click', this.optionClickOutHandler)
  }

  openOption(optionType) {
    const { dom, state } = this
    const activeContainer = dom.$component.querySelector(`.js-fixedOptionsContainer[data-option="${optionType}"]`)
    const activeButton = dom.$component.querySelector(`.js-fixedSingleOptionSelector[data-option="${optionType}"]`)
    activeContainer.classList.add(state.openOptionsClass)
    activeButton.classList.add(state.openOptionsClass)
    document.addEventListener('click', this.optionClickOutHandler)
  }

  optionClick(event) {
    const { dom, state } = this
    const optionValue = event.currentTarget.dataset.value
    const { optionType } = event.currentTarget.dataset
    const currentSelection = dom.$component.querySelector(`.js-fixedOptionBtn[data-value="${state.selectedOptions[optionType]}"]`)

    if (currentSelection) {
      currentSelection.classList.remove(state.selectedOptionClass)
    }

    const formattedStateValue = state.activeSwatch.replace('/', '-').toLowerCase()

    if (optionValue !== formattedStateValue) {
      event.currentTarget.classList.add(state.selectedOptionClass)
      this.closeOpenOption()
      state.selectedOptions[optionType] = optionValue
      state.openOptions = null

      if (optionType === 'color') {
        state.activeSwatch = optionValue
        const { relatedProductUrl } = event.currentTarget.dataset
        window.basis.EventBus.emit('fixed-form-colorchange', { relatedProductUrl, optionValue })
        return
      }

      variantChange(this)
    }
  }

  submit(event) {
    event.preventDefault()
    productFormSubmit(this)
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductFormFixed = this

    // Refresh klarna token when variant changes
    if (typeof window.Klarna !== 'undefined' && window.Klarna.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh()
    }
  }
}
